import { configureI18n } from './configureI18n'
import { fetchManifest } from './api/fetchManifest'

export { i18n } from './i18n'

fetchManifest().then(configureI18n)
